import { OVERLAY_GAP } from '../../../../../shared/helpers/layout-manager/constants';
import {
    NEW_PARTICIPANT_SIZES,
    OLD_PARTICIPANT_SIZES,
} from '../../../../../shared/helpers/layout-manager/get-presenter-layout';
import { ARROW_PADDING } from './presenter-position';

export const DEFAULT_MAX_DISPLAY_PARTICIPANTS = 6;

interface CalcMaxDisplayParticipantsParamsInterface {
    maxDisplayParticipants?: number;
    isNewGrid?: boolean;
    isMobile?: boolean;
    containerWidth?: number | null;
    containerHeight?: number | null;
}

export const calcMaxDisplayParticipants = (params?: Maybe<CalcMaxDisplayParticipantsParamsInterface>) => {
    const gap = params?.isNewGrid ? OVERLAY_GAP : 0;
    const maxDisplayParticipants = params?.maxDisplayParticipants ?? DEFAULT_MAX_DISPLAY_PARTICIPANTS;
    const containerWidth = params?.containerWidth ? params?.containerWidth : window.innerWidth;
    const width = params?.isNewGrid ? containerWidth : containerWidth - ARROW_PADDING * 2;
    let PARTICIPANT_WIDTH: number;
    if (params?.isNewGrid) {
        PARTICIPANT_WIDTH = params.isMobile ? NEW_PARTICIPANT_SIZES.XS_WIDTH : NEW_PARTICIPANT_SIZES.S_WIDTH;
    } else {
        PARTICIPANT_WIDTH = OLD_PARTICIPANT_SIZES.XS_WIDTH;
    }

    if (PARTICIPANT_WIDTH * maxDisplayParticipants + (maxDisplayParticipants - 1) * gap > width) {
        return Math.trunc((width + gap) / (PARTICIPANT_WIDTH + gap));
    }
    return maxDisplayParticipants;
};
